/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable import/prefer-default-export */
/* eslint-disable react/require-default-props */
import React from "react";

type cardProps = {
  children?: React.ReactNode;
  className?: string;
  style?: object;
};

export const Card: React.FC<cardProps> = ({ children, className, style, ...props }) => {
  return (
    <div className={`card ${className}`} style={style} {...props}>
      {children}
    </div>
  );
};

Card.defaultProps = {
  children: undefined,
};
